





































































































import {
  apiActivityIntegralUserCheck,
  ApiActivityIntegralUserCheckRequest,
  ApiTradeGeneralTradePreOrderResponse,
} from '@/api'
import { asRequiredDeep } from 'vtils'
import { computed, ref, set, watch } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent, useHandler } from '@/hooks'
import { mall } from '@/mall_jssdk'
import { Merge, RequiredDeep } from 'vtils/types'
import { router } from '@/router'

type PreOrderData = RequiredDeep<ApiTradeGeneralTradePreOrderResponse>

export default defineClassComponent<{
  preOrderData: Merge<
    PreOrderData,
    {
      orderInfo: Array<
        Merge<
          PreOrderData['orderInfo'][0],
          {
            commodityInfo: Array<
              Merge<
                PreOrderData['orderInfo'][0]['commodityInfo'][0],
                {
                  integralActivity: Merge<
                    PreOrderData['orderInfo'][0]['commodityInfo'][0]['integralActivity'],
                    {
                      count: number
                      countTemp: number
                    }
                  >
                }
              >
            >
          }
        >
      >
    }
  >
}>(
  {
    props: ['preOrderData'],
  },
  ({ props, ctx }) =>
    class {
      constructor() {
        watch(
          () => this.showPicker.value,
          () => {
            if (this.showPicker.value) {
              this.dcdActivity.value.countTemp = this.dcdActivity.value.count
            }
          },
        )

        watch(
          () => this.dcdActivity.value.count,
          () => {
            if (
              this.dcdActivity.value.count != null &&
              this.dcdActivity.value.count !==
                this.dcdActivity.value.initLimitCount
            ) {
              ctx.$emit('change')
            }
          },
        )
      }

      goodsData = computed(() => {
        return props.preOrderData.orderInfo[0].commodityInfo[0]
      })

      dcdActivity = computed(() => {
        if (this.goodsData.value.integralActivity.count == null) {
          set(this.goodsData.value, 'integralActivity', {
            ...this.goodsData.value.integralActivity,
            count: this.goodsData.value.integralActivity.initLimitCount,
            countTemp: this.goodsData.value.integralActivity.initLimitCount,
          })
        }
        return this.goodsData.value.integralActivity
      })

      dcdTotal = computed(() => {
        return mall.calculator.mul(
          this.dcdActivity.value.count,
          this.dcdActivity.value.integral,
        )
      })

      dcdTotalTemp = computed(() => {
        return mall.calculator.mul(
          this.dcdActivity.value.countTemp,
          this.dcdActivity.value.integral,
        )
      })

      dcdDiscountTemp = computed(() => {
        return mall.calculator.mul(
          this.dcdActivity.value.countTemp,
          this.dcdActivity.value.discountAmount,
        )
      })

      showPicker = ref(false)

      bookStyle = router.currentRoute.path.includes('/book/')

      handle = useHandler({
        确定: () => {
          this.dcdActivity.value.count = this.dcdActivity.value.countTemp
          this.showPicker.value = false
        },
      })

      checkResolve!: (skuInfoList: any[]) => any
      checkReject!: () => any
      checkTips = ref('')
      checkJumpUrl = ref('')
      showCheckTips = ref(false)
      checkGetSkuInfoList =
        (): RequiredDeep<ApiActivityIntegralUserCheckRequest>['skuInfoList'] => [
          {
            commodityId: this.goodsData.value.commodityId,
            skuId: this.goodsData.value.skuId,
            quantity: this.dcdActivity.value.count,
          },
        ]
      check = async () => {
        const res = await apiActivityIntegralUserCheck({
          skuInfoList: this.checkGetSkuInfoList(),
        }).then(asRequiredDeep)
        if (res.integralFull) {
          return this.checkGetSkuInfoList()
        }
        this.checkTips.value = res.tipsContent
        this.checkJumpUrl.value = res.url
        return new Promise<any[]>((resolve, reject) => {
          this.checkResolve = resolve
          this.checkReject = reject
          this.showCheckTips.value = true

          const off = watch(
            () => this.showCheckTips.value,
            () => {
              if (!this.showCheckTips.value) {
                off()
                reject()
              }
            },
          )
        })
      }
      checkHandle = useHandler({
        去赚豆豆: () => {
          this.checkReject()
          this.showCheckTips.value = false
          dcb.navigateTo({
            url: this.checkJumpUrl.value,
          })
        },
        原价购买: () => {
          this.dcdActivity.value.count = 0
          this.checkResolve(this.checkGetSkuInfoList())
          this.showCheckTips.value = false
        },
      })
    },
)
